document.addEventListener('keydown',event=>{if(event.key==='Escape'){const menu=document.querySelector('.ed-menu[open]');if(menu){menu.removeAttribute('open');menu.querySelector('summary').focus();}}});
document.addEventListener('click',event=>{const menu=document.querySelector('.ed-menu[open]');if(menu&&!menu.contains(event.target))menu.removeAttribute('open');});

(()=>{
  const sync=()=>document.querySelectorAll('[data-ed-mode-toggle]').forEach(button=>{
    const dark=document.documentElement.dataset.edMode==='dark';
    button.setAttribute('aria-pressed',String(dark));
    button.setAttribute('aria-label',dark?button.dataset.lightLabel:button.dataset.darkLabel);
    button.title=button.getAttribute('aria-label');
  });
  document.addEventListener('click',event=>{
    if(!event.target.closest('[data-ed-mode-toggle]'))return;
    const mode=document.documentElement.dataset.edMode==='dark'?'light':'dark';
    document.documentElement.dataset.edMode=mode;
    try{localStorage.setItem('drp-editorial-mode',mode);}catch(e){}
    sync();
  });
  document.addEventListener('shopify:section:load',sync);
  sync();
})();

(() => {
  let press = null;
  let blockedCard = null;
  let blockedUntil = 0;
  const finish = () => {
    if (!press) return;
    clearTimeout(press.timer);
    press.card.classList.remove('is-previewing');
    press = null;
  };
  document.addEventListener('pointerdown', event => {
    finish();
    blockedCard = null;
    if (event.pointerType !== 'touch' || !event.isPrimary) return;
    const card = event.target.closest('.ed-product__image--alternate');
    if (!card) return;
    const current = { card, id: event.pointerId, x: event.clientX, y: event.clientY, held: false };
    current.timer = setTimeout(() => {
      if (press !== current) return;
      current.held = true;
      card.classList.add('is-previewing');
    }, 350);
    press = current;
  }, { passive: true });
  document.addEventListener('pointermove', event => {
    if (press && event.pointerId === press.id && Math.hypot(event.clientX - press.x, event.clientY - press.y) > 10) finish();
  }, { passive: true });
  document.addEventListener('pointerup', event => {
    if (!press || event.pointerId !== press.id) return;
    if (press.held) {
      blockedCard = press.card;
      blockedUntil = Date.now() + 800;
    }
    finish();
  }, { passive: true });
  document.addEventListener('pointercancel', finish, { passive: true });
  document.addEventListener('scroll', finish, { passive: true, capture: true });
  window.addEventListener('blur', finish);
  document.addEventListener('contextmenu', event => {
    if (press && press.card.contains(event.target)) event.preventDefault();
  });
  document.addEventListener('click', event => {
    const card = event.target.closest('.ed-product__image--alternate');
    if (card && card === blockedCard && Date.now() < blockedUntil) {
      event.preventDefault();
      blockedCard = null;
    }
  });
})();
